<template>
  <InlineSelectorContainer
    class="pb-profiles-list-filter"
  >
    <InlineSelectorItem v-bind="filterProps.official">
      {{ translate('generic.official') }}
    </InlineSelectorItem>
    <InlineSelectorItem v-bind="filterProps.mine">
      {{ translate('generic.mine') }}
    </InlineSelectorItem>
    <InlineSelectorItem v-bind="filterProps.all">
      {{ translate('generic.all') }}
    </InlineSelectorItem>
    <InlineSelectorItem v-bind="filterProps.trash">
      {{ translate('generic.trash') }}
    </InlineSelectorItem>
  </InlineSelectorContainer>
</template>

<script setup>
import InlineSelectorContainer from '@nicolaudie-group/ng-ui-kit/components/InlineSelector/InlineSelectorContainer.vue'
import InlineSelectorItem from '@nicolaudie-group/ng-ui-kit/components/InlineSelector/InlineSelectorItem.vue'
import { useProfileListInject } from '@/composables/useProfileList'
import useTranslate from '@/composables/useTranslate'

const { translate } = useTranslate()

const {
  filter,
} = useProfileListInject()

const {
  filterProps,
} = filter
</script>

<style lang="scss" src="./ProfileListFilters.scss" />
